import { Directive, SkipSelf } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[formSubmittedSync]',
  standalone: true,
})
/**
 * Submits child FormGroup when the parent FormGroup is submitted. Helps ensure validation
 * errors display on nested FormGroups when the parent form is submitted. Use on the
 * nested FormGroup.
 * E.g. <div [formGroup]="childForm" formSubmittedSync>
 */
export class FormSubmittedSyncDirective {
  constructor(
    @SkipSelf() private parentFormGroupDirective: FormGroupDirective,
    private formGroupDirective: FormGroupDirective,
  ) {
    this.parentFormGroupDirective.ngSubmit.asObservable().subscribe(() => {
      (this.formGroupDirective as any).submitted = true;
      this.formGroupDirective.ngSubmit.emit();
    });
  }
}
